import type { FloorPlanItem, FloorPlanLayer } from '../api/floorPlan'
import { Algorithm, DEFAULT_ALGORITHM } from '../edges/EditableEdge/constants'

export function parseLayerId(raw: unknown): number | undefined {
  if (raw === null || raw === undefined || raw === '') return undefined
  const n = Number(raw)
  return Number.isFinite(n) && n > 0 ? n : undefined
}

export function resolveItemLayerId(item: FloorPlanItem, layers: FloorPlanLayer[]): number | undefined {
  const parsed = parseLayerId(item.layer_id)
  if (parsed && layers.some((l) => l.id === parsed)) return parsed
  return layers[0]?.id
}

export function layerById(layers: FloorPlanLayer[], id: number | undefined): FloorPlanLayer | undefined {
  if (id === undefined) return undefined
  return layers.find((l) => l.id === id)
}

export function isLayerVisible(L: FloorPlanLayer | undefined): boolean {
  if (!L) return true
  return Number(L.visible) !== 0
}

export function isLayerLocked(L: FloorPlanLayer | undefined): boolean {
  if (!L) return false
  return Number(L.locked) !== 0
}

export function algorithmFromLayerString(s: string | null | undefined): Algorithm {
  const v = (s ?? '').trim()
  const vals = Object.values(Algorithm) as string[]
  if (vals.includes(v)) return v as Algorithm
  return DEFAULT_ALGORITHM
}

export const ACTIVE_LAYER_STORAGE_KEY = (schemaId: number) => `floor-plan-active-layer-${schemaId}`
